import React, { memo, useEffect, useState } from 'react';
import '../../css/VisitorInformation.css';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/common/ui/Button';
import { RequestsActions } from '../../_store/Requests.slice';
import CustomInput from '../../components/common/CustomInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import CustomModal from '../../components/common/CustomModal ';
import VisitorInformationSchema from '../../validation/VisitorInformationSchema';
import { showAlert } from '../../components/common/showAlert';
import { useNavigate } from 'react-router-dom';
import CheckBoxInput from '../../components/common/ui/Inputs/CheckBoxInput';
import TranslateFile from '../../Loc/TranslateFile';
import Loader from '../../components/common/Loader';
import { getStoredValue  } from "../../_helpers/storageHelper";

const VisitorInformation = ({ isEdit, selectrowItem, handleBack, selectformcategory }) => {
  const [visitors, setVisitors] = useState([{
    requestVisitorInfoID: selectformcategory, visitorOrderNo: 1,
    visitorName: '', dob: '', relation: '', phoneNo: '', streetName: '', city: '', stateNameID: '', zip: ''
  }]);
  const [values, setValues] = useState([{}]);
  const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
  const { InmateRequestVisitorInfoResponse, GetAllStatesDetails, CreateUpdateRequestInmateVisitorResponse } = useSelector(state => state.Requests);
  const storedloginResponse = loginResponse || getStoredValue("loginResponse");
  const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
  const [currentField, setCurrentField] = useState('');
  const [showBoard, setShowBoard] = useState(false);
  const dispatch = useDispatch();
  const allFields = ['visitorName', 'dob', 'relation', 'phoneNo', "streetName", "city", "State", "zip"];
  const keyboardFields = ['visitorName', 'dob', 'relation', 'phoneNo', "streetName", "city", "zip"];
  const [errorMessage, setErrorMessage] = useState({});
  const [isSubmit, setisSubmit] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [modalContent, setmodalContent] = useState();
  const [modalTextColor, setmodalTextColor] = useState('#c8605e');
  const [currentIndex, setcurrentIndex] = React.useState();
  const navigate = useNavigate();
  const currentLang = TranslateFile();
  const placeholder = {
    visitorName: currentLang?.Requests?.Name, dob: currentLang?.Requests?.Dob_Placeholder, relation: currentLang?.Requests?.Relationship,
    phoneNo: currentLang?.Requests?.Phone_Number, streetName: currentLang?.Requests?.Address, city: currentLang?.Requests?.City, zip: currentLang?.Requests?.ZIP
  } 
  const [isLoading, setisLoading] = React.useState(false);

  useEffect(() => {
    if (!isEdit) return;
    const formReqAccess = selectrowItem?.RequestFormTypeID;
    setisLoading(true);
    dispatch(RequestsActions.loadInmateRequestVisitorInfo(formReqAccess)).then(x => {
      setisLoading(false);
      setVisitorsFromResponse(x?.payload);
    });

  }, [isEdit]);

  useEffect(() => {
    dispatch(RequestsActions.loadGetAllStates());
  }, [selectrowItem, isEdit]);

  const setVisitorsFromResponse = (response) => {
    setErrorMessage({});
    if (response?.length > 0) {
      const formattedVisitors = response?.map((visitor, index) => ({
        visitorName: visitor?.VisitorName || '',
        dob: visitor?.DOB || '',
        relation: visitor?.Relation || '',
        phoneNo: visitor?.PhoneNo || '',
        streetName: visitor?.StreetName || '',
        city: visitor?.City || '',
        stateNameID: visitor?.StateNameID || '',
        zip: visitor?.ZIP || '',
        visitorOrderNo: visitor?.VisitorOrderNo,
        RequestVisitorInfoID: visitor?.RequestVisitorInfoID,
        RequestVisitorStatus: visitor?.RequestVisitorStatus,
        IsAddressIncomplete: visitor?.IsAddressIncomplete,
        IsFormerInmate: visitor?.IsFormerInmate,
        IsVistorVictim: visitor?.IsVistorVictim,
        ReqDisApprovedReason: visitor?.ReqDisApprovedReason,
        ReqApproved: visitor?.ReqApproved,
        ReqDisApproved: visitor?.ReqDisApproved
      }));
      setVisitors(formattedVisitors);
    }
  };



  const handleSubmit = async () => {
    setErrorMessage({}); // Reset errors before validation
    const { error } = VisitorInformationSchema(visitors);
    if (error) {
      const newErrors = {};
      // Loop through the error details and filter out specific messages
      error.details.forEach((e, index) => {
        if (e.message !== "The requestVisitorInfoID is required.") {
          if (index == 0)
            handleFieldClick(e.path[1], e.path[0])
          const path = e.path[1] !== undefined ? `${e.path[0]}_${e.path[1]}` : e.path[0];
          newErrors[path] = e.message;
        }
      })

      if (Object.keys(newErrors).length > 0) {
        setErrorMessage(newErrors);
        return;
      }
    }
    const formattedVisitors = visitors?.map((visitor, index) => ({
      ...visitor,
      visitorOrderNo: index + 1,
    }));
    const objdata = {
      typ_RequestVisitorInfos: formattedVisitors,
      requestVisitorFormID: isEdit ? selectrowItem?.RequestFormTypeID : 0,
      facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
      PodCode: storedLoginDetails?.PodCode, inmateResidentId: storedloginResponse?.InmatesResdId,
      actionID: isEdit ? 2 : 1,
    };
    dispatch(RequestsActions.loadCreateUpdateRequestInmateVisitor(objdata)).then(x => {
      if (x?.payload) {
        switch (x?.payload) {
          case 1:
            setmodalContent(currentLang?.AlertPopup?.Request_Sent_Success); setmodalTextColor('#4a9a93');
            break;
          case 2:
            setmodalContent(currentLang?.AlertPopup?.Request_Update_Success); setmodalTextColor('#4a9a93');
            break;
          case -1:
            setmodalContent(currentLang?.AlertPopup?.Update_Failed); setmodalTextColor('#c8605e');
            break;
          case -2:
            setmodalContent(currentLang?.AlertPopup?.NOData_VisitorList); setmodalTextColor('#c8605e');
            break;
          case -3:
            setmodalContent(currentLang?.AlertPopup?.Maximum_Visitor_Form); setmodalTextColor('#c8605e');
            break;
        }
        setShowPopup(true); setisSubmit(false);
      }
    })
    setisSubmit(true);

  };

  const getCurrentDate = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
  };


  const handleFieldClick = (field, index) => {
    setValues(visitors);
    setcurrentIndex(index);
    setCurrentField(field);
    if (field != "stateNameID")
      setShowBoard(true); // Show the keyboard when a field is clicked
  };

  const handleVisitorChange = (id, field, value) => {
    setErrorMessage({ ...errorMessage, [`${currentIndex}_${field}`]: String(value)?.trim()?.length === 0 ? currentLang?.ValidationSchema?.Form_Field_Required : "" });
    setVisitors((prevVisitors) => {
      if (Array.isArray(prevVisitors)) {
        return prevVisitors.map(visitor =>
          visitor.visitorOrderNo === id
            ? { ...visitor, [field]: value }
            : visitor
        );
      }
      return prevVisitors;
    });
  };


  const handleAddVisitor = async () => {
    setErrorMessage({}); // Reset errors before validation
    const { error } = VisitorInformationSchema(visitors);
    if (error) {
      const newErrors = {};
      // Loop through the error details and filter out specific messages
      error.details.forEach((e, index) => {
        if (e.message !== "The requestVisitorInfoID is required.") {
          if (index == 0)
            handleFieldClick(e.path[1], e.path[0])
          const path = e.path[1] !== undefined ? `${e.path[0]}_${e.path[1]}` : e.path[0];
          newErrors[path] = e.message;
        }
      })
      if (Object.keys(newErrors).length > 0) {
        setErrorMessage(newErrors);
        return;
      }
    }
    if (visitors?.filter(x => x?.ReqDisApproved !== 1)?.length == 6 || visitors?.filter(x => x?.ReqDisApproved !== 1)?.length > 6) {
      setShowPopup(true);
      setmodalContent(currentLang?.AlertPopup?.Maximum_Visitor_Form); setmodalTextColor('#c8605e');
    }
    else {
      setVisitors([{
        requestVisitorInfoID: 0, visitorOrderNo: Math.floor(Math.random() * 1000000), visitorName: '', dob: '', relation: '', phoneNo: '',
        streetName: '', city: '', stateNameID: '', zip: ''
      }, ...visitors]);
    }
  };

  const handleRemoveVisitor = (item) => {
    setErrorMessage({});
    setVisitors(visitors.filter(visitor => visitor.visitorOrderNo !== item?.visitorOrderNo));

    if (item?.RequestVisitorInfoID === 0) {
      setShowPopup(true); setmodalContent(item?.RequestVisitorStatus ? currentLang?.AlertPopup?.Visitor_Removed_Success_Please_Click_Submit :
        currentLang?.AlertPopup?.Visitor_Information_Removed_Success)
      setmodalTextColor('#4a9a93')
    } else {
      const removeVisitor = visitors.filter(visitor => visitor.visitorOrderNo !== item?.visitorOrderNo);
      const formattedVisitors = removeVisitor?.map((visitor, index) => ({
        ...visitor,
        visitorOrderNo: index + 1,
      }));
      const objdata = {
        typ_RequestVisitorInfos: formattedVisitors,
        requestVisitorFormID: isEdit ? selectrowItem?.RequestFormTypeID : 0,
        facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        PodCode: storedLoginDetails?.PodCode, inmateResidentId: storedloginResponse?.InmatesResdId,
        actionID: isEdit ? 2 : 1,
      };
      dispatch(RequestsActions.loadCreateUpdateRequestInmateVisitor(objdata)).then(x => {
        if (x?.payload) {
          switch (x?.payload) {
            case 1:
              setmodalContent(currentLang?.AlertPopup?.Request_Sent_Success); setmodalTextColor('#4a9a93');
              break;
            case 2:
              setmodalContent(currentLang?.AlertPopup?.Visitor_Information_Removed_Success); setmodalTextColor('#4a9a93');
              break;
            case -1:
              setmodalContent(currentLang?.AlertPopup?.Update_Failed); setmodalTextColor('#c8605e');
              break;
            case -2:
              setmodalContent(currentLang?.AlertPopup?.NOData_VisitorList); setmodalTextColor('#c8605e');
              break;
            case -3:
              setmodalContent(currentLang?.AlertPopup?.Request_Form_Already_Exist); setmodalTextColor('#c8605e');
              break;
          }
          setShowPopup(true); setisSubmit(false);
        }
      })
    }
  };

  const handleRemoveConfirmation = (item) => {
    showAlert(
      navigate,
      currentLang?.AlertPopup?.Message,
      currentLang?.AlertPopup?.Remove_Confirmation,
      "question",
      "700px",
      "Yes",
      null, // Default redirect URL
      null,  // Redux dispatch function, optional
      null, // Redux action to dispatch, optional (should be passed as a function)
      true,  // Flag to toggle between OK and Yes/No
      "No", // Optional cancel button text if useConfirmCancel is true
      () => { handleRemoveVisitor(item) },
    );
  }


  return (
    <>
      {isLoading && <Loader />}
      <div className="panel panel-default">
        <div className="panel-heading">{currentLang?.Requests?.Visitor_Information}</div>
        <div className="row panel-body">
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Date}</label>
              <input
                type="text"
                className="form-control"
                value={getCurrentDate()}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.ID}</label>
              <input
                type="text"
                className="form-control"
                value={storedloginResponse?.InmatesResdId}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Name}</label>
              <input
                type="text"
                className="form-control"
                value={storedloginResponse?.InmateFullName}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Requests?.Pod}</label>
              <input
                type="text"
                className="form-control"
                value={storedLoginDetails?.PodCode}
                disabled
              />
            </div>
          </div>

          {visitors?.length > 0 && visitors?.map((visitor, index) => (
            <div key={visitor.visitorOrderNo}>
              {index === 0 && (
                <div className="d-flex justify-content-between mb-4 mt-2"  >
                  <div className="d-flex justify-content-end">
                    <Button label={currentLang?.Buttons?.Submit} className='me-2' status="primary" type="submit" onClick={handleSubmit} disabled={isSubmit} isLoading={isSubmit} />
                    <Button label={currentLang?.Buttons?.Reset} className="btn btn-warning" type="button" onClick={() => { setVisitorsFromResponse(InmateRequestVisitorInfoResponse) }} />
                  </div>
                  <div className="align-self-end">
                    <Button label={currentLang?.Buttons?.Add} status="success" type="button" onClick={handleAddVisitor} />
                  </div>
                </div>
              )}
              <div className="row visitors-list visitors-panel-inner">
                <div className='col-lg-12'>
                  {visitor?.RequestVisitorInfoID &&

                    <label className="font-size-16 fw-700 mb-1" style={{ color: visitor?.ReqDisApproved == 1 ? '#c8605e' : '#4a9a93' }}>{visitor?.RequestVisitorStatus || currentLang?.Requests?.New}</label>}
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.Name}
                    type="text"
                    placeholder={currentLang?.Requests?.Name}
                    value={visitor.visitorName}
                    onClick={() => handleFieldClick('visitorName', index)}
                    errorMessage={errorMessage[`${index}_visitorName`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.Dob}
                    type="text"
                    placeholder={currentLang?.Requests?.Dob_Placeholder}
                    value={visitor.dob}
                    onClick={() => handleFieldClick('dob', index)}
                    errorMessage={errorMessage[`${index}_dob`]}
                    required={true}
                    isdisabled={(visitor?.ReqDisApproved == 1 || visitor?.ReqApproved == 1) ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.Relationship}
                    type="text"
                    placeholder={currentLang?.Requests?.Relationship}
                    value={visitor.relation}
                    onClick={() => handleFieldClick('relation', index)}
                    errorMessage={errorMessage[`${index}_relation`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.Phone_Number}
                    type="text"
                    placeholder={currentLang?.Requests?.Phone_Number}
                    value={visitor.phoneNo}
                    onClick={() => handleFieldClick('phoneNo', index)}
                    errorMessage={errorMessage[`${index}_phoneNo`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.Address}
                    type="text"
                    placeholder={currentLang?.Requests?.Address}
                    value={visitor.streetName}
                    onClick={() => handleFieldClick('streetName', index)}
                    errorMessage={errorMessage[`${index}_streetName`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.City}
                    type="text"
                    onClick={() => handleFieldClick('city', index)}
                    placeholder={currentLang?.Requests?.City}
                    value={visitor.city}
                    errorMessage={errorMessage[`${index}_city`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <SelectInput
                    options={GetAllStatesDetails?.length > 0 ? GetAllStatesDetails : []}
                    label={currentLang?.Requests?.State}
                    name={`${index}_stateNameID`}
                    id="state"
                    labelKey="label"
                    valueKey="value"
                    value={visitor.stateNameID}
                    isClearable={false}
                    required
                    placeholder= {currentLang?.placeholder?.Select}
                    handleChange={(e) => handleVisitorChange(visitor?.visitorOrderNo, 'stateNameID', e.value)}
                    errorMessage={errorMessage}
                    isDisabled={visitor?.ReqDisApproved == 1 ? true : false}

                  />

                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <CustomInput
                    label={currentLang?.Requests?.ZIP}
                    type="text"
                    placeholder={currentLang?.Requests?.ZIP}
                    onClick={() => handleFieldClick('zip', index)}
                    value={visitor.zip}
                    errorMessage={errorMessage[`${index}_zip`]}
                    required={true}
                    isdisabled={visitor?.ReqDisApproved == 1 ? true : false}
                  />
                </div>
                {(visitor?.ReqDisApproved != 1 && (visitors?.filter(x => x?.ReqApproved == 1)?.length > 1 && visitor?.ReqApproved == 1)) && <div className="text-right">
                  <Button label={currentLang?.Buttons?.Remove} status="secondary" type="button" onClick={() => handleRemoveConfirmation(visitor)} />
                </div>}
                {((visitor?.ReqDisApproved == undefined && visitor?.ReqApproved == undefined) || (visitor?.ReqDisApproved == 0 && visitor?.ReqApproved == 0)) && <div className="text-right">
                  <Button label={currentLang?.Buttons?.Remove} status="secondary" type="button" onClick={() => handleRemoveConfirmation(visitor)} />
                </div>}
                <div className='col-lg-12 mt-2'>
                  {visitor?.ReqDisApproved == 1 && <> <legend style={{ fontSize: "20px", color: 'black' }}>{currentLang?.Requests?.Disapproval_Section}</legend>
                    {(visitor?.IsAddressIncomplete == 1) &&
                      <CheckBoxInput
                        label={currentLang?.Requests?.Address_InComplete}
                        disabled={true}
                        checked={true}
                      />}
                    {(visitor?.IsFormerInmate == 1) &&
                      <CheckBoxInput
                        label={currentLang?.Requests?.Former_InComplete}
                        disabled={true}
                        checked={true}
                      />}
                    {(visitor?.IsVistorVictim == 1) &&
                      <CheckBoxInput
                        label={currentLang?.Requests?.Vistitor_Victim}
                        disabled={true}
                        checked={true}
                      />}

                    {visitor?.ReqDisApprovedReason?.trim()?.length > 0 && <label className='font-size-16'>{visitor?.ReqDisApprovedReason}</label>}
                  </>
                  }
                </div>
              </div>
            </div>
          ))}
        </div>
        {showPopup && (
          <CustomModal
            color={modalTextColor}
            content={modalContent}
            onOkClick={() => {
              (modalContent == currentLang?.AlertPopup?.Maximum_Visitor_Form || modalContent == currentLang?.AlertPopup?.Visitor_Removed_Success
                || modalContent == currentLang?.AlertPopup?.Visitor_Information_Removed_Success) ? setShowPopup(false) : handleBack()
            }}
          />
        )}
        {showBoard && (
          <div className="card-default">
            <CustomKeyboard
              currentField={currentField}
              setCurrentField={setCurrentField}
              inputs={visitors[currentIndex]}
              setShowBoard={setShowBoard}
              setInputs={setVisitors}
              fields={keyboardFields}
              allFields={allFields}
              handleVisitorChange={handleVisitorChange}
              setErrorMessage={setErrorMessage}
              type="Multiple"
              handleCancel={() => { setVisitors(values) }}
              placeholderList={placeholder}
              visitors={visitors}
              isTabKey={false}
              setValues={setValues}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default memo(VisitorInformation);
